import {
  type PimProductV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'

export const productDataAccessorGetPzn = (
  product: PimProductV11,
): string | undefined => {
  return product.pzn
}

export const productDataAccessorGetDisplayCode = (
  product: PimProductV11,
): string | undefined => {
  return product.display_code
}

export const productDataAccessorGetEan = (
  product: PimProductV11,
): string | undefined => {
  return product.ean
}

export const productDataAccessorGetPharmaForm = (
  product: PimProductV11,
): string | undefined => {
  return product.pharma_form?.label
}

export const productDataAccessorGetManufacturer = (
  product: PimProductV11,
): string | undefined => {
  return product.manufacturer?.name
}

export const productDataAccessorGetManufacturerCode = (
  product: PimProductV11,
): string | undefined => {
  return product.manufacturer?.code
}

export const productDataAccessorGetBrand = (
  product: PimProductWithVariantsV1,
): { name: string; path: string | undefined } | undefined => {
  const variantWithBrand = product.variants.find(
    (variant) => variant.brand?.name !== undefined,
  )

  if (variantWithBrand?.brand?.name) {
    return {
      name: variantWithBrand.brand.name,
      path: variantWithBrand.brand.path,
    }
  }

  return undefined
}
